import { useTranslation } from 'react-i18next';
import type { PageKey } from '../types';
import { LanguageSwitcher } from './LanguageSwitcher';

export function Topbar({
  currentPage,
  onNavigate,
  searchQuery,
  onSearchChange,
}: {
  currentPage: PageKey;
  onNavigate: (page: PageKey) => void;
  searchQuery: string;
  onSearchChange: (q: string) => void;
}) {
  const { t } = useTranslation('nav');
  const placeholder =
    currentPage === 'clients'
      ? t('search_placeholders.clients')
      : currentPage === 'cases'
        ? t('search_placeholders.cases')
        : currentPage === 'documents'
          ? t('search_placeholders.documents')
          : currentPage === 'tasks'
            ? t('search_placeholders.tasks')
            : t('search_placeholders.default');
  const searchActive =
    currentPage === 'clients' ||
    currentPage === 'cases' ||
    currentPage === 'documents' ||
    currentPage === 'tasks';

  return (
    <header className="topbar">
      <div className="topbar-title">{t(`page_titles.${currentPage}`)}</div>

      {searchActive && (
        <div className="search-wrap">
          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            className="search"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            aria-label={placeholder}
          />
        </div>
      )}

      <LanguageSwitcher />

      <button className="btn-new" onClick={() => onNavigate('newcase')}>
        {t('topbar.new_case')}
      </button>
      <button className="btn-new" onClick={() => onNavigate('addclient')}>
        {t('topbar.new_client')}
      </button>
    </header>
  );
}
